<template>
  <div id="vue-app">
    <!-- Header & Navbar -->
    <div
      class="app-flex"
    >
      <div
        class="top-mobile-border"
        v-if="serverConfig.view == 'mobile'"
      />
      <div
        id="header"
        class="header-white"
      >
        <div
          id="navbar-background"
          :class="navbarBackgroundClass"
        />
        <div
          class="navbar"
          justify="start"
        >
          <div
            id="Nav"
          >
            <div
              class="top-bar-flex"
            >
              <div class="flex-row-grow">
                <Burger v-if="serverConfig.view == 'mobile'" />
                <div
                  class="axon-brand"
                  @click="gotoPath('')"
                >
                  <AxonLogo class="axon-brand-mark" />
                </div>
              </div>
              <div class="center-end">
                <div class="flex-row-center">
                  <div class="axon-lang-picker" role="group" aria-label="Language">
                    <button
                      v-for="opt in langOptions"
                      :key="opt.code"
                      class="axon-lang-btn"
                      :class="{ 'is-active': currentLang === opt.code }"
                      :aria-pressed="currentLang === opt.code"
                      @click="setLang(opt.code)"
                    >
                      {{ opt.label }}
                    </button>
                  </div>
                  <div
                    v-if="userInfo?.authorized == true"
                    class="flex-col-app-center"
                    @click="gotoPath('messenger/')"
                  >
                    <div
                      :class="navbarItem"
                    >
                      <div
                        class="messages-icon"
                        v-html="getRawIcon('MESSAGES')"
                      />
                      <div
                        v-if="serverConfig.view != 'mobile'"
                        :class="navbarItem"
                      >
                        {{localize('TEXT_MESSAGES')}}
                      </div>
                    </div>
                  </div>
                  <div
                    class="menu-items"
                    v-if="userInfo.authorized == true"
                    @click="gotoPath('profile')"
                    @mouseenter="showMenu" @mouseleave="hideMenu"
                  >
                    <div class="profile-menu" :class="{ 'show-menu': isMenuVisible }">
                      <div
                        class="menu-item-text"
                        @click.stop="doLogout()"
                      >
                        logout
                      </div>
                    </div>
                    <div class="app-profile-frame">
                      <div
                        id="app-profile-image"
                        class="profile-icon"
                        :style="profileImageStyle"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="app-container">

        <Sidebar class="sidebar">
          <template #mobile>
            <div class="sidebar-panel-nav">
              <div>
                <div
                  class="nav-tab-no-mobile"
                  @click="gotoTab('home')"
                >
                  {{ localize('TEXT_HOME') }}
                </div>
              </div>
              <div
                v-if="userInfo.authorized == false"
              >
                <div
                  class="nav-tab-no-mobile"
                  @click="showLoginModal = true"
                >
                  {{ localize('TEXT_CONNECT') }}
                </div>
              </div>
              <div
                v-if="userInfo.authorized == true"
              >
                <div
                  class="nav-tab-no-mobile"
                  @click="doLogout"
                >
                  {{ localize('TEXT_LOGOUT') }}
                </div>
              </div>
            </div>
          </template>
          <template #desktop-compact>
            <div class="desktop-compact">
            </div>
          </template>
          <template #desktop-expand>
            <div class="desktop-expand">
            </div>
          </template>
        </Sidebar>

        <div :key="$route.path" :class="contentClass">

          <Transition
            name="route"
            mode="out-in"
          >
            <router-view v-slot="{Component}">
              <component
                class="component-margin"
                v-if="$route.path"
                :is="Component"
                :key="$route.fullPath"
              />
            </router-view>
          </Transition>
        </div>
      </div>
      <SVFooter
        @showTerms="showTermsModal = true"
        class="app-footer"
      />
    </div>

    <Transition>
      <div
        v-if="showLoginModal"
        class="modal-overlay"
      >
        <div class="modal-container">
          <div class="modal-header">
            <div> {{ localize('TEXT_LOGIN') }} </div>
            <div class="modal-close" @click="showLoginModal = false">&times;</div>
          </div>
          <div class="modal-body">
            <div class="flex-col">
              <div class="connect-text">
                {{ localize('LOGIN_CONNECT_WALLET') }}
              </div>
              <div class="flex-col connect-wallets">
                <div class="wallet-select-container">
                  <div
                    class="connect-img-container"
                    @click="metamaskLogin"
                  >
                    <img
                      class="connect-img"
                      src="./assets/metamask-small.png"
                    >
                    <div
                      :class="walletText"
                    >
                      MetaMask
                    </div>
                  </div>
                </div>
              </div>
              <Login
                @hide-modal-event="showLoginModal = false"
                @get-userinfo-event="emitAppEvent('getUserInfo')"
              />
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script>
import {inject, nextTick, onBeforeMount, onBeforeUnmount, onMounted, reactive, ref, watch, computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import Axios from "axios";
import Burger from "./components/Burger.vue";
import SVFooter from "./components/SVFooter.vue";
import Sidebar from "./components/Sidebar.vue";
import Login from "./components/Login.vue";
import AxonLogo from "./components/AxonLogo.vue";
import {iconStore} from "@/stores/icon";
import {mutations} from "@/stores/sidebar.js";
import {translationStore} from "@/stores/translation";


export default {
    "name": "App",
    components: {
        Burger,
        Sidebar,
        SVFooter,
        Login,
        AxonLogo
    },
    setup (_, {emit}) {

        const eBus = inject("eBus"),
            contentClass = ref(""),
            emitAppEvent = (e, d) => {

                eBus.emit(
                    "app-event",
                    {
                        "action": e,
                        "data": d
                    }
                );

            },
            name = ref(""),
            email = ref(""),
            navMenu = ref("menu-container"),
            isMenuVisible = ref(false),
            icon = iconStore(),
            lastScrollPosition = ref(0),
            navbarSearchBG = ref('navbar-search-light'),
            navbarItem = ref('navbar-item-dark'),
            navbarBackgroundClass = ref("navbar-background-tall"),
            selectedProvider = ref(),
            userProfile = inject("profile"),
            route = useRoute(),
            router = useRouter(),
            serverConfig = inject("serverConfig"),
            showTermsModal = ref(false),
            showLoginModal = ref(false),
            translation = translationStore(),
            userInfo = inject("userInfo"),
            walletText = ref("wallet-text-desktop"),
            web3 = inject("web3"),
            eth = inject("eth"),
            showMenu = function () {

                isMenuVisible.value = true;

            },
            hideMenu = function () {

                isMenuVisible.value = false;

            },
            profileImageStyle = computed(() => {

                if (userProfile.value?.image) {
                    return {
                        backgroundImage: `url(${process.env.VUE_APP_SERVER_URI}${userProfile.value.image})`,
                        borderRadius: "50%",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    };
                }
                return {};

            }),
            metamaskLogin = function () {

                localStorage.setItem(
                    "selectedProvider",
                    "metamask"
                );

                emitAppEvent(
                    "getWeb3",
                    "login"
                );

            },
            doLogout = function () {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}/logout`,
                    {
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            emitAppEvent("getUserInfo");

                        }

                    });

            },
            getURL = function (endpoint) {

                return `${process.env.VUE_APP_SERVER_URI + endpoint}`;

            },
            getIcon = function (i) {

                if (serverConfig.visualMode === "dark") {

                    return icon.get(`${i}_DARK`);

                }
                return icon.get(`${i}_LIGHT`);

            },
            getRawIcon = function (i) {

                return icon.get(`${i}`);

            },
            gotoTab = function (t) {

                if (t === "home" && serverConfig.view === "mobile") {

                    mutations.toggleMobileNav();

                }
                router.push({"name": t,
                    "path": `/${t}`}).catch((err) => {

                    throw err;

                });

            },
            gotoPath = function (t) {

                router.push({"path": `/${t}`}).catch((err) => {

                    throw err;

                });

            },
            handleScroll = function () {

                const n = document.getElementById("navbar-background"),
                    h = document.getElementById("header"),
                    s = window.scrollY;

                if (s > lastScrollPosition.value && s > 50) {

                    h.style.top = "-0px";
                    navbarBackgroundClass.value = "navbar-background-short";

                } else {

                    h.style.top = "0px";
                    navbarBackgroundClass.value = "navbar-background-tall";

                }

                if (s < 50) {

                    n.style.backgroundColor = "rgba(255, 255, 255, 0)";
                    n.style.backdropFilter = "none";
                    n.style.webkitBackdropFilter = "none";
                    if (window.innerWidth <= 768) {
                        n.style.height = "150px"
                    } else {
                      n.style.height = "80px"
                    }
                    serverConfig.visualMode = "light";
                    navbarSearchBG.value = "navbar-search-light";
                    navbarItem.value = "navbar-item-light";

                } else {

                    if (window.innerWidth <= 768) {
                        n.style.height = "150px"
                    } else {
                      n.style.height = "80px"
                    }
                    // Frosted glass on scroll — translucent so the canvas
                    // (and rest of page) shows through with a subtle blur.
                    n.style.backgroundColor = "rgba(255, 255, 255, 0.55)";
                    n.style.backdropFilter = "blur(14px) saturate(140%)";
                    n.style.webkitBackdropFilter = "blur(14px) saturate(140%)";
                    serverConfig.visualMode = "light";
                    navbarSearchBG.value = "navbar-search-light";
                    navbarItem.value = "navbar-item-light";

                }
                lastScrollPosition.value = s;

            },
            updateView = function () {

                if (serverConfig.view === "desktop") {

                    contentClass.value = "desktop-content";
                    walletText.value = "wallet-text-desktop";

                } else if (serverConfig.view === "tablet") {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-desktop";

                } else if (serverConfig.view === "mobile") {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-mobile";

                } else {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-mobile";

                }

            };

        // ---- language picker ----
        const langOptions = [
            { code: "en", label: "EN" },
            { code: "ar", label: "AR" },
            { code: "ja", label: "JA" },
        ];
        const currentLang = computed(() =>
            translation.VUE_APP_USER_LANGUAGE || translation.getLang().slice(0, 2)
        );
        const setLang = (code) => {
            translation.setLanguage(code);
            // Set <html lang> so screen readers / hyphenation know the language.
            // Skipping `dir="rtl"` for Arabic for now since the layout isn't
            // RTL-adapted; browsers handle inline bidi for Arabic glyphs.
            document.documentElement.lang = code;
        };

        onBeforeMount(() => {

            document.title = process.env.VUE_APP_DOMAIN || "App";

        });

        onMounted(() => {

            if (route.path == 'login/') {

                showLoginModal.value = true;

            }

            updateView();
            handleScroll();

            nextTick(async () => {

                await router.isReady();

                window.addEventListener(
                    "scroll",
                    handleScroll
                );

                if (route.query.hl) {

                    translation.setLanguage(route.query.hl);

                }

                if (route.query.ha) {

                    if (route.query.ha === "login") {

                        showLoginModal.value = true;

                    }

                }

            });

            eBus.on(
                "app-event",
                (e) => {

                    switch (e.action) {

                    case "showLoginModal":
                        showLoginModal.value = true;

                    }

                }
            );

            watch(
                () => route.name,
                () => {

                    updateView();

            });

            watch(
                () => serverConfig.view,
                () => {

                    updateView();

            });

            watch(
                () => userInfo.authorized,
                () => {

                    selectedProvider.value = localStorage.getItem("selectedProvider");

                    if (userInfo.authorized === true) {

                        showLoginModal.value = false;

                    }

            });

        });

        onBeforeUnmount(() => {

            window.removeEventListener(
                "scroll",
                handleScroll
            );

        });

        return {contentClass,
            userInfo,
            userProfile,
            profileImageStyle,
            walletText,
            doLogout,
            emitAppEvent,
            selectedProvider,
            navMenu,
            navbarItem,
            navbarSearchBG,
            email,
            name,
            isMenuVisible,
            showMenu,
            hideMenu,
            getURL,
            getIcon,
            getRawIcon,
            gotoTab,
            gotoPath,
            eBus,
            handleScroll,
            metamaskLogin,
            langOptions,
            currentLang,
            setLang,
            "icon": icon.get,
            lastScrollPosition,
            "localize": translation.localize,
            navbarBackgroundClass,
            route,
            serverConfig,
            showLoginModal,
            showTermsModal,
            updateView,
            web3,
            eth};

    }
};

</script>

<style>

#Nav {
  width:100%;
}
#vue-app {
  position: relative;
  height: 100%;
  font-family: 'PTSans-Regular', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 1.15em;
  scroll-behavior: smooth;
}
[v-cloak] {
    display: none !important;
}
a {
  text-decoration: none;
}
a.nav-link {
  color: white;
  padding: 0;
}
a.nav-link:hover {
  cursor: pointer;
}
.layout {
  width:350px;
  margin-left: auto;
  margin-right: auto;
}
#background {
  position: absolute;
  width: 100%;
  overflow: hidden;
}
.navbar {
  display: flex;
  flex-direction: column;
  padding: 10px 24px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  text-align: left;
  width: 100%;
  /* Match the page content width (.axon-container is 1280) so the header
     logo lines up with the sections below. */
  max-width: 1280px;
  z-index: 3;
}
.profile-icon {
  cursor: pointer;
  width: 56px;
  height: 56px;
}
#header {
  position: fixed;
  width: 100%;
  transition: top .33s ease-in-out;
  -moz-transition: top .33s ease-in-out;
  -webkit-transition: top .33s ease-in-out;
  z-index: 2;
}
.header-white {
  display: flex;
  background-color: none;
}
.app-container {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}
#navbar-background {
  position: fixed;
  width: 100%;
  height: 80px;
}
.navbar-background-tall {
  z-index: 3;
  padding: 15px;
  transition: all .25s ease-in-out;
}
.navbar-background-short {
  z-index: 3;
  padding: 15px;
  transition: all .25s ease-in-out;
}
.top-bar-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  /* Fixed to the bar height so an oversized logo overflows it (centered)
     instead of stretching the header taller. */
  height: 60px;
  overflow: visible;
}
.flex-row-grow {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
}
.flex-row-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-col-app-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.uchan-logo {
  width: 56px;
  height: 56px;
  cursor: pointer;
  background-image: url("./assets/logo.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.axon-brand {
  display: flex;
  align-items: center;
  cursor: pointer;
  height: 60px;
  user-select: none;
  /* Let the oversized mark spill beyond the bar without growing the header. */
  overflow: visible;
}
.axon-brand-mark {
  height: 100px;
  width: auto;
  flex: 0 0 auto;
}
.axon-brand-word {
  font-family: var(--axon-font-display, 'Manrope', sans-serif);
  font-weight: 700;
  font-size: 1.3rem;
  letter-spacing: 0.02em;
  color: #0A2540;
  text-transform: none;
  line-height: 1;
  transition: color 220ms ease;
}
.axon-brand:hover .axon-brand-word {
  color: #1E6FB0;
}

/* Language picker — frosted pill in the header. Each language is a small
   pill button; the active one fills with deep navy + white text. */
.axon-lang-picker {
  display: inline-flex;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.7);
  box-shadow: 0 4px 12px -6px rgba(13, 50, 80, 0.18);
  margin-right: 12px;
}
.axon-lang-btn {
  padding: 5px 11px;
  font-family: var(--axon-font-body, 'Inter', sans-serif);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  border: none;
  background: transparent;
  color: var(--axon-ink-700, #2A322D);
  border-radius: 999px;
  cursor: pointer;
  line-height: 1;
  transition: background 200ms ease, color 200ms ease;
}
.axon-lang-btn:hover:not(.is-active) {
  background: rgba(255, 255, 255, 0.7);
  color: var(--axon-ink-900, #0A0F0C);
}
.axon-lang-btn.is-active {
  background: #1F3A5F;
  color: #FFFFFF;
}
.messages-icon {
  width: 24px;
  height: 24px;
  margin: 5px;
}
.profile-login {
  width: 32px;
  height: 32px;
  cursor: pointer;
  background-image: url("./assets/login-icon.png");
  background-repeat: no-repeat;
  background-size: contain;
}
.navbar-item-light {
  color: #333;
  font-size: 0.8em;
  text-align: center;
  cursor: pointer;
}
.navbar-item-dark {
  color: #fff;
  font-size: 0.8em;
  text-align: center;
  cursor: pointer;
}
.menu-items {
  cursor: pointer;
  margin: 0 10px;
}
.profile-menu {
  display: none;
  position: absolute;
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,.2);
  padding: 10px;
  margin-top: 60px;
  z-index: 10;
}
.profile-menu.show-menu {
  display: block;
}
.menu-item-text {
  padding: 5px 10px;
  cursor: pointer;
}
.menu-item-text:hover {
  text-decoration: underline;
}
.app-profile-frame {
  display: flex;
  align-items: center;
  justify-content: center;
}
.app-flex {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.top-mobile-border {
  height: 50px;
}
.desktop-content {
  width: 100%;
  padding-top: 100px;
  min-height: 80vh;
}
.mobile-content {
  width: 100%;
  padding-top: 160px;
  min-height: 80vh;
}
.component-margin {
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 20px;
}
.nav-tab-no-mobile {
  padding: 15px;
  font-size: 1.2em;
  cursor: pointer;
}
.nav-tab-no-mobile:hover {
  text-decoration: underline;
}
.sidebar-panel-nav {
  display: flex;
  flex-direction: column;
}
.desktop-compact {
  padding: 20px;
}
.desktop-expand {
  padding: 20px;
}
.app-footer {
  margin-top: auto;
}
.hidden {
  display: none;
}

/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
.modal-container {
  background: white;
  border-radius: 15px;
  max-width: 500px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-size: 1.2em;
  font-weight: bold;
  border-bottom: 1px solid #eee;
}
.modal-close {
  cursor: pointer;
  font-size: 1.5em;
}
.modal-body {
  padding: 20px;
}
.connect-text {
  margin-bottom: 20px;
  color: #555;
}
.connect-wallets {
  margin-bottom: 20px;
}
.wallet-select-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}
.connect-img-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 1px solid #ddd;
  border-radius: 10px;
  cursor: pointer;
  transition: box-shadow .2s ease;
}
.connect-img-container:hover {
  box-shadow: 0 2px 10px rgba(0,0,0,.2);
}
.connect-img {
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
}
.wallet-text-desktop {
  font-size: 0.9em;
}
.wallet-text-mobile {
  font-size: 0.8em;
}

/* Route transitions */
.route-enter-active,
.route-leave-active {
  transition: opacity 0.2s ease;
}
.route-enter-from,
.route-leave-to {
  opacity: 0;
}


</style>
